// extracted by mini-css-extract-plugin
module.exports = {"main":"Step_main__PRJIt","step_number":"Step_step_number__2OILZ","step_description":"Step_step_description__3P3DX"};